import { ChangeDetectorRef, Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { EnvironmentService } from '@app-core';
import { AlertComponent, FooterComponent, HeaderComponent, ToastComponent } from '@app-shared';
import { fadeInAnimation } from 'app/animations';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, AlertComponent, HeaderComponent, FooterComponent, ToastComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    animations: [fadeInAnimation],
})
export class AppComponent implements OnInit {
    private readonly environmentService = inject(EnvironmentService);
    private readonly cdr = inject(ChangeDetectorRef);
    title = 'Dewar Claim Respondent';

    ngOnInit(): void {
        this.environmentService.logEnvironmentVars();
    }

    ngAfterViewInit(): void {
        this.cdr.detectChanges(); // Trigger change detection after the view has been initialized
    }

    prepareRoute(outlet: RouterOutlet) {
        return outlet?.activatedRouteData?.['animation'] ?? 'rootPage';
    }
}
